import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LineLogo from '../img/line.png';
import CheckAdmin from "./checkAdmin";
import { MdDarkMode, MdLightMode } from "react-icons/md";

const isAuthenticated = !!localStorage.getItem('mau_user');
const username = localStorage.getItem("mau_user_name");
const typeUser = (localStorage.getItem("mau_user_type") === "dev") ? localStorage.getItem("mau_user_type") : null;
function NavbarMenu() {
    const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [darkMode]);

    const toggleDarkMode = () => {
        const newMode = !darkMode;
        setDarkMode(newMode);
        localStorage.setItem('darkMode', newMode);
    };

    return (
        <Navbar
            expand="lg"
            className={`border-bottom ${darkMode ? 'bg-dark text-light' : 'bg-body-tertiary text-dark'}`}
        >
            <Container>
                <Navbar.Brand as={Link} to="/" className={`${darkMode ? 'text-light' : 'text-dark'}`}>
                    <img className="nav-logo" src={LineLogo} alt="Logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className={`me-auto ${darkMode ? 'text-light' : 'text-dark'}`}>
                        {isAuthenticated ? (
                            <>
                                <Nav.Link as={Link} to="/account" className={`${darkMode ? 'text-light' : 'text-dark'}`}>
                                    <span>
                                        {localStorage.getItem("mau_user_img") != "null" ? (
                                        <img
                                            src={`/img/${localStorage.getItem("mau_user_img")}`}
                                            alt="Profile"
                                            style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "10px" }}
                                        />
                                    ) : (
                                        <i className="bi bi-person-circle"></i>
                                    )}
                                    </span> {(typeUser ? typeUser.toUpperCase() : null)} {username}
                                </Nav.Link>

                                <Nav.Link as={Link} to="/logout" className={`${darkMode ? 'text-light' : 'text-dark'}`}>
                                    <i className="bi bi-box-arrow-in-left"></i> Odhlásit
                                </Nav.Link>
                            </>
                        ) : (
                            <>
                                <Nav.Link as={Link} to="/login" className={`${darkMode ? 'text-light' : 'text-dark'}`}>
                                    <i className="bi bi-box-arrow-in-right"></i> Přihlásit
                                </Nav.Link>
                            </>
                        )}
                        {(localStorage.getItem("mau_user_type") !== "user" && isAuthenticated) ? (
                            <Nav.Link as={Link} to="/create" className={`${darkMode ? 'text-light' : 'text-dark'}`}>
                                <i className="bi bi-folder-plus"></i> Vytvořit nový příběh
                            </Nav.Link>
                        ) : null}
                    </Nav>
                    <button
                        onClick={toggleDarkMode}
                        className={`btn btn-${darkMode ? 'dark' : 'light'}`}
                        style={{ marginLeft: 'auto' }}
                    >
                        {darkMode ? <MdLightMode/> : <MdDarkMode />}
                    </button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavbarMenu;
